var _module_exports = "<div class=\"wait-dialog\">\n    <tr-dialog instance=\"dialog\" disable-close=\"true\">\n        <div class=\"message\">{{message}}</div>\n    </tr-dialog>\n</div>";;
var path = '/src/Client/Directives/wait-dialog/wait-dialog.html';
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;